import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

type Allowed = Array<'admin'|'user'|'customer'>;

export function RoleRoute({ allow }: { allow: Allowed }) {
  const { role } = useAuth();
  if (!allow.includes((role as any) || '')) {
    const fallback = role === 'customer' ? '/adopter/dashboard' : '/dashboard';
    return <Navigate to={fallback} replace />;
  }
  return <Outlet />;
}
